import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Get field mappings
 */
export const getFieldMappings = async () => {
  try {
    const fullUrl = `${API_BASE_URL}/field-mappings`;
    console.log('Making field mappings request to:', fullUrl);
    
    const response = await axios.get(fullUrl, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Field mappings response received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching field mappings:', error);
    console.error('Error details:', error.response?.data);
    throw error;
  }
};

export default {
  getFieldMappings
}; 